import useGetAllStatisticsByUser from './useGetAllStatisticsByUser'

export default useGetAllStatisticsByUser
